import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';
import { DialogService } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { TrustBadgeService } from '../../services/trust-badge.service';
import { ApkService } from '../apk/apk.service';
import { OfferState } from '../policy-creator/store/offer.state';
import { PolicyCreatorState } from '../policy-creator/store/policy-creator.state';
import { SharedModule } from '../shared/shared.module';
import { WarrantyCreatorState } from '../warranty-creator/store/warranty-creator.state';
import { WarrantyOfferState } from '../warranty-creator/store/warranty-offer.state';
import { BuyComponent } from './buy/buy.component';
import { CtaLoadingDialogComponent } from './buy/cta-loading-dialog/cta-loading-dialog.component';
import { BuyComponentWarranty } from './buy/warranty/buy-warranty.component';
import { CtaMainComponent } from './cta-main.component';
import { CtaRoutingModule } from './cta-routing.module';
import { DocumentsUploadBoxComponent } from './documents-upload-box/documents-upload-box.component';
import { DocumentsUploadComponent } from './documents-upload/documents-upload.component';
import { DocumentsUploadedDialogComponent } from './documents-uploaded-dialog/documents-uploaded-dialog.component';

@NgModule({
  declarations: [
    DocumentsUploadBoxComponent,
    DocumentsUploadComponent,
    DocumentsUploadedDialogComponent,
    CtaMainComponent,
    BuyComponent,
    BuyComponentWarranty,
    CtaLoadingDialogComponent,
  ],
  imports: [
    CommonModule,
    CtaRoutingModule,
    TranslocoModule,
    SharedModule,
    FileUploadModule,
    NgxsModule.forFeature([
      PolicyCreatorState,
      OfferState,
      WarrantyCreatorState,
      WarrantyOfferState,
    ]),
  ],
  providers: [DialogService, ApkService, TrustBadgeService],
})
export class CtaModule {}
